import React from "react";
import styles from "../component/custom.module.css";
import Images from "./Images";
import Nav from "../component/Nav";
import Modal from "react-modal";
import { useState } from "react";

const mainPost = {
  video_url: "https://www.youtube.com/embed/i334JTo1F3Q",
  author: {
    name: "Salim Merchant",
    bio: "Score composer, Music director",
  },
};

const posts = [
  {
    // "name": "Ms. Divya Dutta",
    // "bio": "Actor, Poet & Author",
    "link": "ob4hEm-Fx5U",
    "thumbnail": require('../assets/export-videos/expert-divya-dutta.webp'),
  },
  {
    "thumbnail": require('../assets/export-videos/expert-sussanne-khan.webp'),
    "link": "KU99a2Uz9DY",
  },
  {
    // "name": "Ms. Avantika Bahuguna ",
    // "bio": "Influencer, Community Builder & Business Leader ",
    "thumbnail": require('../assets/export-videos/expert-manya-singh.webp'),
    "link": "-GYLb-VN4DM",
  },
  {
    "thumbnail": require('../assets/export-videos/expert-malini-agarwal.webp'),
    "link": "t9DeZeyEhTc",
  },
  {
    "thumbnail": require('../assets/export-videos/expert-avantika-bahuguna.webp'),
    "link": "yoINERkO-Cw",
  },
  {
    "thumbnail": require('../assets/export-videos/expert-tanya-khubchandani-vatsa.webp'),
    "link": "wR5bnK0orvI",
  },


]

const dduta = posts[3]
const avantikaB = posts[1]

const ExpertVideos = ({ executeScroll }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState(mainPost.video_url);
  function openModal(videoUrlSrc) {
    setVideoUrl(videoUrlSrc);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <section className={styles.BannerSection}>
      <h2 className="mb-3">Expert Videos​</h2>
      <div className="container-fluid">
        <div className={`col-lg-12 col-md-12 ${styles.womenEmpoweringSection}`}>
          <div className={styles.VideoSectionLeftInner}>
            {posts.map((post) => (
            <div key={post.link} className={styles.VideoSectionLeftInnerName}>
              <img
                src={post.thumbnail}
                onClick={() =>
                  openModal(`https://www.youtube.com/embed/${post.link}`)
                }
              />
            </div>
            ))}

          </div>
        </div>
        <Modal
          style={{
            content: {
              display: "flex",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderWidth: 0,
              flexDirection: "column",
              flex: 1,
              position: "unset",
              height: "100%",
              overflow: "auto",
              justifyContent: "center",
            },
          }}
          // overlayClassName={Modalstyle.modal}
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
        >
          <div className="container">
            <div className={styles.modalVideo}>
              <img
                className={styles.modalClose}
                src={Images.Cancel}
                onClick={closeModal}
              />
              {modalIsOpen && (
                <iframe
                  width="100%"
                  height="394"
                  src={videoUrl + "?&autoplay=1&rel=0"}
                  title="Video"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              )}
            </div>
          </div>
        </Modal>
      </div>
    </section>
  );
};

export default ExpertVideos;
